<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g mask="url(#mask-home-storage)">
            <mask id="mask-home-storage" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <path
                d="M6.95976 20.1931C6.52343 20.1931 6.13601 20.0502 5.79751 19.7643C5.45901 19.4787 5.25217 19.1178 5.17701 18.6816L3.77101 10.2556C3.72501 9.97943 3.78909 9.73326 3.96326 9.51709C4.13726 9.30109 4.36809 9.19309 4.65576 9.19309H19.3443C19.6319 9.19309 19.8628 9.30109 20.0368 9.51709C20.2109 9.73326 20.275 9.97943 20.229 10.2556L18.823 18.6816C18.7478 19.1178 18.541 19.4787 18.2025 19.7643C17.864 20.0502 17.4766 20.1931 17.0403 20.1931H6.95976ZM5.40001 10.6931L6.63651 18.4336C6.64934 18.5104 6.68301 18.5729 6.73751 18.6211C6.79201 18.6691 6.85776 18.6931 6.93476 18.6931H17.0653C17.1423 18.6931 17.208 18.6691 17.2625 18.6211C17.317 18.5729 17.3507 18.5104 17.3635 18.4336L18.6 10.6931H5.40001ZM10 14.4431H14C14.2125 14.4431 14.3906 14.3712 14.5343 14.2273C14.6781 14.0835 14.75 13.9053 14.75 13.6928C14.75 13.4802 14.6781 13.3021 14.5343 13.1586C14.3906 13.0149 14.2125 12.9431 14 12.9431H10C9.78751 12.9431 9.60942 13.015 9.46576 13.1588C9.32192 13.3027 9.25001 13.4808 9.25001 13.6933C9.25001 13.906 9.32192 14.0842 9.46576 14.2278C9.60942 14.3713 9.78751 14.4431 10 14.4431ZM6.00001 8.00084C5.78751 8.00084 5.60942 7.92893 5.46576 7.78509C5.32192 7.64126 5.25001 7.46309 5.25001 7.25059C5.25001 7.03793 5.32192 6.85984 5.46576 6.71634C5.60942 6.57268 5.78751 6.50084 6.00001 6.50084H18C18.2125 6.50084 18.3906 6.57276 18.5343 6.71659C18.6781 6.86043 18.75 7.03859 18.75 7.25109C18.75 7.46376 18.6781 7.64184 18.5343 7.78534C18.3906 7.92901 18.2125 8.00084 18 8.00084H6.00001ZM8.00001 5.30859C7.78751 5.30859 7.60942 5.23668 7.46576 5.09284C7.32192 4.94901 7.25001 4.77084 7.25001 4.55834C7.25001 4.34568 7.32192 4.16759 7.46576 4.02409C7.60942 3.88043 7.78751 3.80859 8.00001 3.80859H16C16.2125 3.80859 16.3906 3.88051 16.5343 4.02434C16.6781 4.16818 16.75 4.34634 16.75 4.55884C16.75 4.77151 16.6781 4.94959 16.5343 5.09309C16.3906 5.23676 16.2125 5.30859 16 5.30859H8.00001Z"
                fill="currentColor"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'home-storage-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
    },
};
</script>
    